<script>
export default {
  props: {
    news: {
      type: Object,
    },
  },
};
</script>

<template>
<div>
  <router-link
    :to="{name: 'userpage', params: {type: 'profile', id: news.textParams[0]}}"
    class="member-name"
  >{{news.textParams[1]}}</router-link>
  {{$t('news.template.minister.revoked.p1')}}
  {{news.textParams[2]}}
  {{$t('news.template.minister.revoked.p2')}}
  {{news.textParams[3]}}
</div>
</template>
